import { useNavigate } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevronLeft.svg";
import {
  BackButton,
  Container,
  Image,
  ImageContainer,
  List,
  ListItem,
  Text,
  AppStoreSvg,
  GooglePlaySvg,
  ChromeSvg,
  TextContainer,
  Title,
  VideoWrapper,
  StyledIframe,
} from "./TutorialsPages.styles";

import Image1 from "../../assets/images/Image06.png";
import Image2 from "../../assets/images/Image07.png";
import Image3 from "../../assets/images/Image08.png";
import Image4 from "../../assets/images/Image09.png";
import Image5 from "../../assets/images/Image10.png";
import Image6 from "../../assets/images/Image01.png";
import Image7 from "../../assets/images/Image02.png";
import Image8 from "../../assets/images/Image11.png";
import Image9 from "../../assets/images/Image12.png";
import Image10 from "../../assets/images/Image13.png";
import Image11 from "../../assets/images/Image14.jpg";
import Image12 from "../../assets/images/Image15.jpg";
import Image13 from "../../assets/images/Image16.jpg";
import Image14 from "../../assets/images/Image17.jpg";
import Image15 from "../../assets/images/Image18.png";
import Image16 from "../../assets/images/Image19.jpg";
import Image17 from "../../assets/images/Image20.jpg";

const CryptoTutorialPage = () => {
  const navigate = useNavigate();
  const src = `https://www.youtube.com/embed/EyNnvug3AdQ?rel=0`;

  const handleEmailClick = () => {
    const recipient = "support@playbun.com";

    const subject = "Support Request - Playbun.com";
    const body = `Hello Support Team,

I am experiencing the following issue:

[Please describe your problem here]

Thank you,
[Your Name]`;

    // Encode subject and body for the URL
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    const mailtoLink = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
    window.location.href = mailtoLink;
  };

  const handleBack = () => {
    navigate(-1);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };
  return (
    <MainContainer>
      <Container>
        <BackButton onClick={handleBack}>
          <ChevronSvg />
          Back
        </BackButton>
        <TextContainer>
          <Title>How to purchase credits using Crypto</Title>
          <Text>
            If you are new to cryptocurrency, the first step you can take is to
            get a wallet or exchange app. If you already have cryptocurrency,
            please jump to step 3.
          </Text>
        </TextContainer>

        <TextContainer>
          <Title>Step 1: Get a wallet app</Title>
          <Text>
            There are many cryptocurrency wallet apps to choose from. Here, we
            will use Trust Wallet as an example. You can choose to download it
            from the Apple or Google app stores, or use the browser extension.
            (Click the icon below to download)
          </Text>
          <ImageContainer>
            <AppStoreSvg
              onClick={() => {
                window.open(
                  "https://apps.apple.com/us/app/trust-crypto-bitcoin-wallet/id1288339409",
                  "_blank",
                );
              }}
            />
            <GooglePlaySvg
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.wallet.crypto.trustapp",
                  "_blank",
                );
              }}
            />
            <ChromeSvg
              onClick={() => {
                window.open(
                  "https://chromewebstore.google.com/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph",
                  "_blank",
                );
              }}
            />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Text>
            After downloading Trust Wallet, the next step is to create your
            first wallet according to the app's guidance (don't forget to back
            up your seed phrase to avoid losing it).
          </Text>
          <ImageContainer>
            <Image src={Image1} />
            <Image src={Image2} />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Title>Step 2: Buying Cryptocurrency in the Trust Wallet App</Title>
          <Text>
            On the Wallet homepage, click the "Fund" button to enter the
            purchase page, then click the "Buy Crypto" button, enter the fiat
            currency you want to use and the cryptocurrency you want to buy.
          </Text>
          <Text>
            Here, the price may fluctuate depending on your region and the
            amount of Crypto you wish to purchase. Please note that this
            purchase step may require you to complete KYC.
          </Text>
          <Text>
            We recommend choosing BNB (on Binance Smart Chain) for your
            purchase, as its transaction speed is very fast and transaction fees
            are extremely low.
          </Text>
          <ImageContainer>
            <Image src={Image3} $small />
            <Image src={Image4} $small />
            <Image src={Image5} $small />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Title>
            Step 3: Generate an order on our website purchased with Crypto
          </Title>
          <Text>
            On the subscription page, select your desired subscription and click
            to pay using Crypto.
          </Text>
          <ImageContainer>
            <Image src={Image6} $small />
            <Image src={Image7} $small />
            <Image src={Image8} $small />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Title>Step 4: Complete the payment in your wallet app</Title>
          <Text>
            On the Nowpayments order page that pops up, select the currency and
            network you wish to pay with (note: this step must be correct). If
            you purchased BNB in the step 2, then you need to select BNB here
            (and on the Binance Smart Chain).
          </Text>
          <Text>Then, you need to copy the payment amount and address.</Text>
          <ImageContainer>
            <Image src={Image9} $small />
            <Image src={Image10} $small />
            <Image
              src={Image11}
              $small
              style={{ maxHeight: 416.42, objectPosition: "bottom" }}
            />
          </ImageContainer>
          <Text>
            In the Trust Wallet App, select the cryptocurrency you wish to pay
            with (e.g., BNB), then tap "Send," enter the address you just copied
            and the amount, and once the payment is complete, you're all set!
          </Text>

          <ImageContainer>
            <Image src={Image12} $small />
            <Image src={Image13} $small />
            <Image src={Image14} $small />
          </ImageContainer>
        </TextContainer>

        <TextContainer>
          <Title>Tips</Title>
          <List>
            <ListItem>
              The most common error for failed payments is not selecting the
              correct currency and network on the Nowpayments order page (by
              default, it is USDT on BSC).{" "}
              <Text $bold>
                Please be sure to select both the correct currency and network
              </Text>
              . For example, if you pay with USDT on the ETH network without
              making any changes, this will also cause the order to get stuck.
            </ListItem>
            <ListItem>
              Another common mistake is when an order gets stuck in a partially
              paid state, which usually happens because you forgot to pay the
              gas fee when making the payment. (However, this generally won't
              occur with the Trust Wallet App or BNB mentioned above, as Trust
              Wallet is designed to calculate the gas fee independently of the
              amount to be paid, and BNB's gas fee is extremely low, practically
              negligible.) Nevertheless,{" "}
              <Text $bold>
                if you are using other wallet apps, be sure to ensure that the
                actual amount paid (after deducting the gas fee) equals the
                amount on the order page
              </Text>
              , otherwise, your payment may get stuck.
            </ListItem>
            <ListItem>
              If you encounter any payment issues, please contact our{" "}
              <Text $link onClick={handleEmailClick}>
                support email
              </Text>{" "}
              with your payment information: screenshots, the order ID and
              payment ID from the webpage, the payment address from the webpage
              (case-sensitive), and the successful transaction Tx hash.
            </ListItem>
          </List>
        </TextContainer>

        <TextContainer>
          <Title>Bonus: Buy credits from cryptocurrency exchange app</Title>
          <Text>
            Besides decentralized wallet apps, you can also buy and send virtual
            currency from exchange apps, which often allows you to purchase
            cryptocurrency at a more favorable price.
          </Text>
          <Text>
            Below, using Binance exchange as an example, you can watch the
            tutorial video to learn how to install and use Binance exchange.
          </Text>

          <VideoWrapper>
            <StyledIframe
              src={src}
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </VideoWrapper>

          <Text>
            After purchasing cryptocurrency through the Binance exchange, you
            will proceed from step 3 above, generating a purchase order on our
            website and completing the withdrawal within your Binance app to
            make the payment.
          </Text>
          <Text>
            It is worth noting that exchange apps typically do not calculate the
            gas fee separately when withdrawing. As shown in the image below,
            you need to <Text $bold>include the gas fee in your payment</Text>{" "}
            to ensure the final payment amount matches that on the NowPayments
            webpage.
          </Text>

          <ImageContainer>
            <Image src={Image15} $small />
            <Image src={Image16} $small />
            <Image src={Image17} $small />
          </ImageContainer>
        </TextContainer>
      </Container>
    </MainContainer>
  );
};

export default CryptoTutorialPage;
